import { ACTIVE_DESIGN_SYSTEM } from '@/config/designSystem'
import HomePageEase from './home/HomePageEase'
import HomePageLegacy from './home/HomePageLegacy'

/**
 * Homepage entry — switches composition by ACTIVE_DESIGN_SYSTEM.
 * Set `ACTIVE_DESIGN_SYSTEM` to `'legacy'` in src/config/designSystem.ts to rollback.
 */
const HomePage = () => {
  if (ACTIVE_DESIGN_SYSTEM === 'legacy') {
    return <HomePageLegacy />
  }
  return <HomePageEase />
}

export default HomePage
